<script>

import {
  deleteOrganization,
  getBranches,
  getOrganizations,
  getRegions,
  updateOrganization
} from '@/api/organizations/organizations';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import Button from '@/components/ui/Button.vue';
import Card from '@/components/ui/Card.vue';
import AddButton from '@/views/organizations/components/AddButton.vue';
import BaseHeader from '@/views/organizations/components/BaseHeader.vue';
import DeleteButton from '@/views/organizations/components/DeleteButton.vue';
import EditButton from '@/views/organizations/components/EditButton.vue';
import MainCard from '@/views/organizations/components/MainCard.vue';

export default {
  name: 'Index',
  components: { DeleteButton, EditButton, BaseHeader, Breadcrumbs, AddButton, MainCard, Card, Button },
  data() {
    return {
      items: [],
      editKey: null,
      organizationName: null,
    };
  },
  methods: {
    getOrganizations() {
      switch (this.$route.name) {
        case 'organizations':
          getOrganizations().then(response => {
            this.items = response.data;
          });
          break;
        case 'regions':
          getRegions(this.$route.params).then(response => {
            this.items = response.data;
          });
          break;
        case 'branches':
          getBranches(this.$route.params).then(response => {
            this.items = response.data;
          });
          break;
      }
    },
    editOrganization(item) {
      this.editKey = item.id;
      this.$nextTick(() => {
        const input = this.$refs['organizationNameInput' + item.id];
        const realInput = Array.isArray(input) ? input[0] : input;

        realInput?.focus?.();
      });
    },
    updateOrganization(item) {
      updateOrganization(item.id, item).then(() => {
        this.editKey = null;

        const organizationType = item.type === 'region' ? 'Дирекція' : 'Відділення';

        this.$message({
          type: 'success',
          message: `${organizationType} оновлено`
        });
      });
    },
    deleteOrganization(item) {
      const organizationType = item.type === 'region' ? 'дирекцію' : 'відділення';

      this.$confirm(`Ви дійсно бажаєте видалити, ${organizationType}: ${item.name}`, {
        confirmButtonText: 'Так',
        cancelButtonText: 'Ні',
        type: 'warning'
      }).then(() => {
        deleteOrganization(item.id).then(() => {
          this.getOrganizations();
          const organizationType = item.type === 'region' ? 'Дирекція' : 'Відділення';

          this.$message({
            type: 'success',
            message: `${organizationType} видалено`
          });
        }
        );

      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Видалення скасовано'
        });
      });

    }
  },
  created() {
    this.getOrganizations();
  }
};
</script>

<template>
    <div>
        <BaseHeader @saved="getOrganizations" />
        <el-row v-if="$route.name === 'organizations'">
            <el-col  v-for="item in items" :xs="24" :sm="24" :md="12" :lg="12" :xl="12" :span="12" :key="item.id">
                <MainCard :organization="item"/>
            </el-col>
        </el-row>
        <el-row v-else :gutter="16">
            <el-col v-for="item in items" :xs="24" :sm="24" :md="12" :lg="8" :xl="8" :span="8" :key="item.id" class="mb-3">
                <Card class="equal-height">
                    <template v-slot:title>
                        <el-row type="flex" justify="space-between">
                            <el-col>
                                <div v-if="editKey === item.id">
                                    <input
                                        required
                                        :ref="'organizationNameInput' + item.id"
                                        type="text"
                                        class="form-control"
                                        @blur="updateOrganization(item)"
                                        v-model="item.name"
                                    >
                                </div>
                                <div v-else>
                                    {{ item.name }}
                                </div>
                            </el-col>
                            <el-col :span="4" class="d-flex">
                                <EditButton @click="editOrganization(item)" class="ml-1 mr-1"/>
                                <DeleteButton @click="deleteOrganization(item)"/>
                            </el-col>
                        </el-row>
                    </template>

                    <div class="flex-wrapper mb-8">
                        <div v-if="$route.name !== 'branches'">
                            {{ item.total_branches_count }} відділень
                        </div>
                        <div>
                            <router-link v-if="$route.name === 'branches'"
                                         tag="div"
                                         :to="{name: 'branches.managers', params: {...$route.params, branchId: item.id}}">
                                {{ item.total_users_count }} менеджерів
                            </router-link>
                            <router-link v-else
                                         tag="div"
                                         class="cursor-pointer"
                                         :to="{name: 'regions.managers', params: {...$route.params, regionId: item.id}}">
                                {{ item.total_users_count }} менеджерів
                            </router-link>
                        </div>
                    </div>
                    <div class="footer">
                        <router-link
                            v-if="$route.name === 'branches'"
                            :to="{name: 'branches.managers', params: {...$route.params, branchId: item.id}}"
                            class="footer-button"
                        >
                            <Button>Перейти до менеджерів</Button>
                        </router-link>
                        <router-link v-else :to="{name: 'branches', params: {...$route.params, regionId: item.id}}" class="footer-button">
                            <Button>Перейти до відділень</Button>
                        </router-link>
                        <router-link :to="{name: $route.name + '.tariff-settings', params: {...$route.params, [item.type + 'Id']: item.id}}" class="footer-button">
                            <Button>Налаштувати тариф</Button>
                        </router-link>
                    </div>
                </Card>
            </el-col>
        </el-row>
    </div>
</template>

<style scoped lang="scss">
.flex-wrapper {
    display: flex;
    gap: 16px;
}

.footer {
    /* Frame 1000005958 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    gap: 8px;

    flex: none;
    order: 1;
    flex-grow: 0;
}

.mb-8 {
    margin-bottom: 2rem;
}

.header-page {
    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 8px;

    .title {
        font-family: Geist,serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        color: #09090B;

        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
    }
}

@media (max-width: 550px) {
    .footer {
        flex-direction: column;

        &-button {
            width: 100%;
        }
    }
}
</style>
